import React from 'react';
import { COMPANY_LOGO, COMPANY_NAME, APP_PRODUCT_NAME } from '../../../config/brandingConfig';
import { formatDateTimeIN } from '../../../utils/dateFormat';

const ReportCover = ({ meta }) => {
  const logoSrc =
    typeof window !== 'undefined' && COMPANY_LOGO?.startsWith('/')
      ? `${window.location.origin}${COMPANY_LOGO}`
      : COMPANY_LOGO;
  return (
    <section id="sm-cover" className="sm-cover sm-report-cover sm-print-cover">
      <div className="sm-cover__strip" aria-hidden />
      <div className="sm-cover__inner">
        <div>
          <div className="sm-cover__brand">
            <img className="sm-cover__logo" src={logoSrc} alt="" />
            <div>
              <h1 className="sm-cover__title">Senior Management Information Report</h1>
              <p className="sm-cover__subtitle">{COMPANY_NAME}</p>
            </div>
          </div>
          <p className="sm-toolbar-note" style={{ marginTop: 8 }}>
            {APP_PRODUCT_NAME} — factual counts, values, dates, statuses, and references only.
          </p>
        </div>
        <aside className="sm-cover__meta-card">
          <h3>Report details</h3>
          <div className="sm-cover__meta-row">
            <span className="sm-cover__meta-label">Reporting period</span>
            <span className="sm-cover__meta-value">{meta ? `${meta.from} → ${meta.to}` : '—'}</span>
          </div>
          <div className="sm-cover__meta-row">
            <span className="sm-cover__meta-label">Project / portfolio</span>
            <span className="sm-cover__meta-value">{meta?.projectName || 'All projects in scope'}</span>
          </div>
          <div className="sm-cover__meta-row">
            <span className="sm-cover__meta-label">Generated on</span>
            <span className="sm-cover__meta-value">{meta ? formatDateTimeIN(new Date(meta.generatedAt)) : '—'}</span>
          </div>
          <div className="sm-cover__meta-row">
            <span className="sm-cover__meta-label">Generated by</span>
            <span className="sm-cover__meta-value">
              {meta ? `${meta.generatedByName || '—'} (${meta.generatedByEmail || '—'})` : '—'}
            </span>
          </div>
        </aside>
      </div>
    </section>
  );
};

export default ReportCover;
